import { GridValueFormatterParams, GridValueGetterParams } from '@mui/x-data-grid-pro'
import dayjs from 'dayjs'
import { formatCurrencyFromCents } from './transformers'

class GridFormatters {
  formatLongDate(params: GridValueFormatterParams<dayjs.ConfigType>): string {
    return params.value ? dayjs(params.value).format('LLL') : '-'
  }

  formatDateOnly(params: GridValueFormatterParams<dayjs.ConfigType>): string {
    return params.value ? dayjs(params.value).format('MMM D, YYYY') : '-'
  }

  formatTimestamp(params: GridValueFormatterParams<number>): string {
    return params.value ? dayjs.unix(params.value).format('LLL') : '-'
  }

  formatCurrency(params: GridValueFormatterParams<number>): string {
    return formatCurrencyFromCents(params.value)
  }

  addCurrencySign(params: GridValueFormatterParams<string | number>): string {
    return `$${params.value}`
  }

  formatShortDate(params: GridValueFormatterParams<dayjs.ConfigType>): string {
    if (!params.value) {
      return '-'
    }

    const date = dayjs(params.value)
    const format = date.isSame(dayjs(), 'year') ? 'MMM D, LT' : 'LLL'

    return date.format(format)
  }

  formatSimpleDate(params: GridValueFormatterParams<dayjs.ConfigType>): string {
    return params.value ? dayjs.unix(params.value as number).format('MMM D, YYYY') : '-'
  }
}

export const gridFormatters = new GridFormatters()

export class GridComparators {}

export const gridComparators = new GridComparators()

export class GridValueGetters {
  parseDate(params: GridValueGetterParams<any, string>): Date | null {
    if (!params.value) {
      return null
    }

    return dayjs(params.value).toDate()
  }

  parseDateUTC(params: GridValueGetterParams<any, string>): Date | null {
    if (!params.value) {
      return null
    }

    return dayjs.utc(params.value).toDate()
  }

  parseTimestamp(value?: number | null): Date | null {
    return value ? dayjs.unix(value).toDate() : null
  }

  parseUnixTimestamp(params: GridValueGetterParams<any, string>): Date | null {
    const raw = params.value

    return raw ? dayjs.unix(Number(raw)).toDate() : null
  }
}

export const gridValueGetters = new GridValueGetters()
